import PageBanner from 'components/banners/PageBanner';
import Features from 'components/Features';

import React from 'react';
import { Col, Container, Image, Row } from 'react-bootstrap';
import teamWorkImage from 'assets/images/housing-assistance-cap60.jpeg';
import styles from './programs.module.scss';
import { Helmet } from 'react-helmet';
import RequestDemoButton from 'components/RequestDemoButton';
// const REPORT_DATA = [
//   {
//     title: 'Features',
//     items: [
//       'Building information intake',
//       'Real-time tracking of client activities, including face-to-face counseling or group counseling',
//       'Customized forms in compliance with HUD 9902 of funding',
//       'Expense and budget forms available to assist with housing planning',
//       'Service tracking for payments, deposits, and placement',
//       'Comprehensive case, client and service reports to show client progress over time and housing self-sufficiency',
//       'HUD 9902 forms and reports with ability to securely transfer for HUD database',
//       'Document & assessment tracking',
//     ],
//   },
// ];

const FEATURE_DATA = [
  {
    id: 1,
    title: 'Building information intake',
  },
  {
    id: 2,
    title:
      'Real-time tracking of client activities, including face-to-face counseling or group counseling',
  },
  {
    id: 3,
    title: 'Customized forms in compliance with HUD 9902 of funding',
  },
  {
    id: 4,
    title: 'Expense and budget forms available to assist with housing planning',
  },
  {
    id: 5,
    title: 'Service tracking for payments, deposits, and placement',
  },
  {
    id: 6,
    title:
      'Comprehensive case, client and service reports to show client progress over time and housing self-sufficiency',
  },
  {
    id: 7,
    title:
      'HUD 9902 forms and reports with ability to securely transfer for HUD database',
  },
  {
    id: 8,
    title: 'Document & assessment tracking',
  },
];
function HousingAssistance() {
  return (
    <div>
      <Helmet>
        <title>Versatile Housing Program Module - CAP60</title>
        <meta
          name="description"
          content="CAP60 manages all aspects of Housing Assistance programs, from one-on-one to group counseling;  client education classes and sessions;  through comprehensive reporting features."
        />
        <meta
          name="keywords"
          content="housing assistance, cap60 housing assistance"
        />
      </Helmet>
      <PageBanner
        title="Housing Assistance"
        subtitle="Versatile Housing Program Module"
      />
      <div className="floralbg-white">
        <Container className="overflow-auto">
          <CommunityServices />
        </Container>
      </div>
      {/* <SampleReport data={REPORT_DATA} title="Reports" /> */}
      <div className="floralbg-white">
        <Container className="overflow-auto">
          <Features
            data={FEATURE_DATA}
            variant="primary"
            title="Features"
            itemsPerRow="4"
            subtitle="Dig in to know what make CAP60 Solutions unique and useful"
          />
        </Container>
      </div>
    </div>
  );
}
//
function CommunityServices() {
  return (
    <div className={styles.communityServicesWrap}>
      <Row className="align-items-center">
        <Col md="5">
          <Image src={teamWorkImage} fluid className="p-3 mb-4 mb-md-0" />
        </Col>
        <Col md="7">
          <div className="heading">
            <h2>Versatile Housing Program Module</h2>
          </div>
          <p>
            CAP60 manages all aspects of Housing Assistance programs, from
            one-on-one to group housing counseling, client education classes and
            sessions, and temporary and rapid re- housing accompanied by
            comprehensive reporting features. <br />
            CAP60 maintains a connection to HUD database to allow for secure,
            compliant transfer of 9902 forms and reports from CAP60.
          </p>
          <RequestDemoButton />
        </Col>
      </Row>
    </div>
  );
}

export default HousingAssistance;
